var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useEffect, useState } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { toast } from 'react-toastify';
import { generateRoute, translate } from '@js/common/helpers';
import { initAuth } from '@js/common/auth/modalHandler';
import { softNavigate } from '@ts/common/navigation/BrowseRouter';
import { SettingsStoreInstance } from '@ts/common/service-instance/SettingsStoreInstance';
import { ImageSearchDeniedModal } from '@ts/homepage/search/component/imageSearch/ImageSearchFreeModals';
import { ImageSearchQuotaModal } from '@ts/homepage/search/component/imageSearch/ImageSearchQuotaModal';
import { getImageSearchAccess, runLookImageSearch, } from '@ts/homepage/search/component/imageSearch/imageSearch';
var BUTTON_SELECTOR = '.image-search-look-button';
var LOADING_CLASS = 'image-search-look-button--loading';
export var LOOK_IMAGE_SEARCH_FOUND_EVENT = 'image-search-look:found';
var buttonsBound = false;
export function isImageSearchEnabled() {
    return __awaiter(this, void 0, void 0, function () {
        var config, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, SettingsStoreInstance.getSearchConfig()];
                case 1:
                    config = _a.sent();
                    return [2, (config === null || config === void 0 ? void 0 : config.image_search_enabled) === true];
                case 2:
                    e_1 = _a.sent();
                    return [2, false];
                case 3: return [2];
            }
        });
    });
}
export function useImageSearchEnabled() {
    var _a = useState(false), enabled = _a[0], setEnabled = _a[1];
    useEffect(function () {
        var mounted = true;
        isImageSearchEnabled().then(function (value) {
            if (mounted) {
                setEnabled(value);
            }
        });
        return function () {
            mounted = false;
        };
    }, []);
    return enabled;
}
function showModal(renderModal) {
    var root = document.createElement('div');
    document.body.appendChild(root);
    function close() {
        unmountComponentAtNode(root);
        root.remove();
    }
    render(renderModal(close), root);
}
function showPaywall(denial, access) {
    showModal(function (close) { return (React.createElement(ImageSearchDeniedModal, { isOpen: true, onClose: close, access: access, denial: denial, catalog: true })); });
}
export function searchWithLook(slug, onFound) {
    return __awaiter(this, void 0, void 0, function () {
        var access, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getImageSearchAccess()];
                case 1:
                    access = _a.sent();
                    if (!access.logged && access.denial !== 'login_required') {
                        initAuth('image_search');
                        return [2];
                    }
                    if (access.quotaExceeded) {
                        showModal(function (close) { return React.createElement(ImageSearchQuotaModal, { isOpen: true, onClose: close }); });
                        return [2];
                    }
                    if (access.denial !== null) {
                        showPaywall(access.denial, access);
                        return [2];
                    }
                    return [4, runLookImageSearch(slug)];
                case 2:
                    result = _a.sent();
                    if (result.status === 'ok') {
                        onFound === null || onFound === void 0 ? void 0 : onFound();
                        window.scrollTo({ top: 0 });
                        softNavigate(generateRoute('look_search', { image_search: '1', similar_to: slug }));
                        return [2];
                    }
                    if (result.status === 'payment_required') {
                        showPaywall(result.denial, access);
                        return [2];
                    }
                    if (result.status === 'quota_exceeded') {
                        showModal(function (close) { return React.createElement(ImageSearchQuotaModal, { isOpen: true, onClose: close }); });
                        return [2];
                    }
                    if (result.status === 'unavailable') {
                        toast.error(translate('image_search.errors.unavailable'));
                        return [2];
                    }
                    toast.error(translate('image_search.errors.process_failed'));
                    return [2];
            }
        });
    });
}
export function bindLookImageSearchButtons() {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, isImageSearchEnabled()];
                case 1:
                    if (!(_a.sent())) {
                        return [2];
                    }
                    document.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
                        button.hidden = false;
                    });
                    if (buttonsBound) {
                        return [2];
                    }
                    buttonsBound = true;
                    document.addEventListener('click', function (event) { return __awaiter(_this, void 0, void 0, function () {
                        var button;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    button = event.target.closest(BUTTON_SELECTOR);
                                    if (!button || !button.dataset.slug || button.disabled) {
                                        return [2];
                                    }
                                    event.preventDefault();
                                    button.disabled = true;
                                    button.classList.add(LOADING_CLASS);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, , 3, 4]);
                                    return [4, searchWithLook(button.dataset.slug, function () {
                                            button.dispatchEvent(new CustomEvent(LOOK_IMAGE_SEARCH_FOUND_EVENT, { bubbles: true }));
                                        })];
                                case 2:
                                    _a.sent();
                                    return [3, 4];
                                case 3:
                                    button.disabled = false;
                                    button.classList.remove(LOADING_CLASS);
                                    return [7];
                                case 4: return [2];
                            }
                        });
                    }); });
                    return [2];
            }
        });
    });
}
